import { useState } from 'react';
import { Flex, Modal, Typography } from 'antd';
import classNames from 'classnames';
import { MButton } from '@Components/Base';
// import useResizeLayout from '@Hooks/useResizeLayout';

import { ReactComponent as MaterialslIcon } from '@Icons/additional/drop-box.svg';
import { ReactComponent as MaterialsActivelIcon } from '@Icons/additional/drop-box-gradient.svg';
import { ReactComponent as AttachmentslIcon } from '@Icons/additional/link-2-diagonal.svg';
import { ReactComponent as AttachmentsActivelIcon } from '@Icons/additional/link-2-diagonal-gradient.svg';

import styles from './CopyRequestModal.module.css';

interface CopyRequestModalProps {
  id: string | null;
  isOpen: boolean;
  onSuccess: (isMaterials: boolean, isAttachments: boolean) => void;
  onCancel: () => void;
}

const CopyRequestModal: React.FC<CopyRequestModalProps> = ({
  id,
  isOpen,
  onSuccess,
  onCancel,
}) => {
  const [isMaterials, setIsMaterials] = useState(false);
  const [isAttachments, setIsAttachments] = useState(false);

  const handleSuccess = (): void => {
    onSuccess(isMaterials, isAttachments);
    setIsMaterials(false);
    setIsAttachments(false);
  };

  const customButtons = [
    <MButton key="back" type="tertiary" onClick={onCancel}>
      No, Thanks
    </MButton>,
    <MButton
      key="submit"
      type="primary"
      onClick={handleSuccess}
      disabled={!isMaterials && !isAttachments}
    >
      Confirm
    </MButton>,
  ];

  return (
    <Modal
      open={isOpen}
      onCancel={onCancel}
      className={styles.modal}
      footer={customButtons}
      closeIcon={false}
      width={400}
    >
      <Flex vertical>
        <Flex className={styles.titleSection}>
          <Typography.Text className={styles.title}>
            Copy Request No. {id}
          </Typography.Text>
        </Flex>
        <div className={styles.messageSection}>
          Please select the items you want to copy. You can choose multiple
          options.
        </div>
        <div className={styles.cardsWrapper}>
          <div
            className={classNames(styles.card, {
              [styles.active]: isMaterials,
            })}
            onClick={() => setIsMaterials(!isMaterials)}
          >
            {isMaterials ? <MaterialsActivelIcon /> : <MaterialslIcon />}
            <Typography.Text className={styles.cardText}>
              Materials
            </Typography.Text>
          </div>

          <div
            className={classNames(styles.card, {
              [styles.active]: isAttachments,
            })}
            onClick={() => setIsAttachments(!isAttachments)}
          >
            {isAttachments ? <AttachmentsActivelIcon /> : <AttachmentslIcon />}

            <Typography.Text className={styles.cardText}>
              Attachments
            </Typography.Text>
          </div>
        </div>
      </Flex>
    </Modal>
  );
};

export default CopyRequestModal;
